<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <div class="pb-1"><modal-link modal-id="How to Use"></modal-link>{{ title }}</div>
    </div>
    <div class="survey-status container">
      <div class="d-flex">
        <div class="form-group form-inline">
          <label for="startDate" class="mr-1">Start Date</label>
          <datepicker format="MMM dd yyyy" v-model="startDate" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="startDate"></datepicker>
        </div>
        <div class="form-group form-inline ml-2">
          <label for="endDate" class="mr-1">End Date</label>
          <datepicker format="MMM dd yyyy" v-model="endDate" :typeable="true" wrapper-class="" input-class="form-control required w-100 bg-white" name="endDate"></datepicker>
        </div>
        <div class="pr-2">
          <button type="button" class="btn btn-primary ml-2" id="AddNewContentButton" @click="loadData()">Run</button>
        </div>
      </div>
      <table :id="table.id" :class="table.class" cellspacing="0" width="100%">
        <thead></thead>
        <tbody></tbody>
      </table>
      <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
        <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
      </div>
    </div>
  </div>
</template>
<script>
import RespondentMixins from "../../mixins/RespondentMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import Datepicker from "vuejs-datepicker";

import SurveySummaryService from "../../services/survey.summary.service";

export default {
  name: "SurveyStatus",
  mixins: [RespondentMixins, DataTableMixins],
  components: { Datepicker },
  props: {},
  data() {
    return {
      table: {
        id: "survey-status-download-data",
        columns: SurveySummaryService.getSurveyStatusTableColumnData()
      },
      pageNumber: 12,
      startDate: new Date(2014, 1, 1),
      endDate: new Date(),
      title: "Survey Status"
    };
  },
  methods: {
    async getTableData() {
      this.$root.processServerRequest();
      SurveySummaryService.getSummaryDataByClientIdAndDate(this.startDate, this.endDate, this.getTableDataCallback, this);
    },
    loadData: function() {
      this.getTableData();
      this.table.configuration.order = [[1, "desc"]];
      this.table.configuration.dom = "frtpB";
    }
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {}
};
</script>
